import {Button} from "primereact/button";
import {Tooltip} from "primereact/tooltip";

export const allowExpansion = rowData => {
	return rowData.enabled_template_types.length > 0;
};

export const statusBodyTemplate = (rowData, url) => {
	return (
		<>
			<a href={url} target="_blank" id={`button_id_${rowData.id}`}>
				<Button label="download zip" icon={"pi pi-download"} severity={"success"} rounded />
			</a>
			<Tooltip
				target={`#button_id_${rowData.id}`}
				content="Download process files as zip"
				position="left"
			/>
		</>
	);
};

export const processProgressBody = rowData => {
	const totalProcesses = rowData.enabled_template_types?.length || 0;
	const completedProcesses =
		rowData.enabled_template_types?.filter(t => t.uploaded_file).length || 0;
	const completedPercentage =
		totalProcesses > 0 ? Math.round((completedProcesses / totalProcesses) * 100) : 0;
	let progressColor = "#6c757d";
	if (completedPercentage > 30) progressColor = "#fd7e14";
	if (completedPercentage > 60) progressColor = "#17a2b8";
	if (completedPercentage === 100) progressColor = "#28a745";

	return (
		<div
			className="position-relative w-100 mt-3"
			style={{height: "8px", background: "#e0e0e0", borderRadius: "6px"}}>
			<div
				style={{
					height: "100%",
					width: `${completedPercentage}%`,
					backgroundColor: progressColor,
					borderRadius: "6px",
					transition: "width 0.3s ease-in-out",
				}}
			/>
			<div
				className="position-absolute w-100 text-center fw-bold"
				style={{
					fontSize: "10px",
					lineHeight: "12px",
					bottom: "15px",
				}}>
				process completed by{" "}
				<span className="fw-bold" style={{color: progressColor}}>
					{completedPercentage}
				</span>
				%
			</div>
		</div>
	);
};
